/**
 *
 * UserBox
 *
 */

import "./index.less"

import { Avatar, Button, Dropdown, Menu, message } from "antd"
import {
  KEY_ACTIVE_ROL,
  KEY_MODULES,
  KEY_TRANSFER_USER,
  KEY_USER_ID,
  KEY_USER_NAME,
  KEY_USER_PHOTO,
  LOCAL_ACTIVE_ROL,
  LOCAL_AMBASSADOR_ID,
  LOCAL_EMPLOYEE_ID,
  LOCAL_TRANSFER_USER,
  LOCAL_USER_ID,
  LOCAL_USER_PHOTO,
  LOCAL_USER_ROLES,
  isAmbassador,
  isAmbassadorActive,
  isLeader,
  setItem,
  clearStorage,
  LOCAL_MODULES,
  KEY_AMBASSADOR_ID,
} from "../../utils/storage"
import { Link, withRouter } from "react-router-dom"
import {
  ROLES_ADMIN,
  ROLE_AMBASSADOR,
  ROLE_LEADER,
  CODE_FETCHING,
} from "../../utils/constants"

import EmptySvg from "../EmptySvg"
import React from "react"
import { UserOutlined } from "@ant-design/icons"
import checkIcon from "images/check-measure.svg"
import down from "../../images/down.svg"
import iconEngagement from "images/engagement.svg"
import { uuid } from "../../utils/functions"
import { loadTexts } from "../../utils/i18n"

/* eslint-disable react/prefer-stateless-function */
class UserBox extends React.Component {
  intl = loadTexts("header")
  state = {
    visibleUserInfo: false,
  }

  idRoleToFetch = () => {
    if (this.props.changeRole === "Embajador") return ROLE_AMBASSADOR

    if (this.props.changeRole === "Líder") return ROLE_LEADER

    let userRoles = JSON.parse(LOCAL_USER_ROLES())
    let result = userRoles.find(
      (rol) => rol.id != ROLE_AMBASSADOR && rol.id !== ROLE_LEADER
    )
    return result.id
  }

  changeRoleProfile = async () => {
    try {
      const result = await fetchGlobalApi({
        method: "POST",
        endpoint: `users/${LOCAL_USER_ID()}/change-role`,
        data: { id_role: this.idRoleToFetch() },
      })
      const { user } = result.data.data.result
      setItem(KEY_USER_ID, user.id)
      setItem(KEY_USER_NAME, user.name)
      setItem(KEY_USER_PHOTO, user.picture_profile)
      setItem(KEY_MODULES, JSON.stringify(user.modules))
      setItem(KEY_ACTIVE_ROL, user.id_role)
      if (user.id_role === ROLE_AMBASSADOR || user.id_role === ROLE_LEADER) {

        if (validRole({ role: [5] })) {
          setItem(KEY_AMBASSADOR_ID, user.id_ambassador)
          return window.location.replace(`/ambassador/${LOCAL_AMBASSADOR_ID()}`)
        }
        return window.location.replace(`/leader/${LOCAL_AMBASSADOR_ID()}`)
      }
      return window.location.replace("/organization")
    } catch (error) {
      if (error.response.status === CODE_FETCHING.error.Unauthorized) {
        clearStorage()
        window.location.replace("/login")
      }
      returnMessage(error)
    }
  }

  redirectPerformance = async () => {
    try {
      const result = await fetchGlobalApi({
        method: "GET",
        endpoint: `performance-transfer/hash`,
      })
      const { data } = result.data
      window.open(data.url, "_self")
    } catch (error) {
      if (typeof error.message !== "undefined" && error.message !== null) {
        if (error.message === "Network Error") {
          message.error("Error al ingresar a la plataforma de Desempeño.", 3)
        }
      }
      if (error.response.status) {
        setItem(KEY_TRANSFER_USER, false)
      }
      returnMessage(error)
    }
  }

  changeRole = async () => {
    try {
      const result = await fetchGlobalApi({
        method: "POST",
        endpoint: `users/${LOCAL_USER_ID()}/change-role`,
        data: { id_role: this.idRoleToFetch() },
      })
      const { user } = result.data.data.result
      setItem(KEY_USER_ID, user.id)
      setItem(KEY_USER_NAME, user.full_name)
      setItem(KEY_USER_PHOTO, user.picture_profile)
      setItem(KEY_MODULES, JSON.stringify(user.modules))
      setItem(KEY_ACTIVE_ROL, user.id_role)
      if (user.id_role === ROLE_AMBASSADOR || user.id_role === ROLE_LEADER) {
        setItem(KEY_AMBASSADOR_ID, user.id_ambassador)
        const modules = JSON.parse(LOCAL_MODULES())

        let dashboardModule = modules.find((mod) => mod.slug === "dashboard")

        if (dashboardModule?.mode === "disable")
          return window.location.replace("/reports")
        return window.location.replace("/")
      }
      return window.location.replace("/organization")
    } catch (error) {
      if (error.response.status === CODE_FETCHING.error.Unauthorized) {
        clearStorage()
        window.location.replace("/login")
      }
      returnMessage(error)
    }
  }

  openMenu = (visibleUserInfo) => {
    this.setState({ visibleUserInfo })
  }

  render() {
    const {
      history,
      dataObject: { picture_profile, first_name, email, last_name, id_role },
      changeRole,
    } = this.props

    let split_first_name = ""
    if (first_name !== undefined && first_name !== null) {
      split_first_name = first_name.split(" ")[0]
    }
    const transfer_user = LOCAL_TRANSFER_USER()
    const user_is_leader = isLeader()
    const user_is_ambassador = isAmbassadorActive()
    let isProfile = false
    let redirectProfile = null
    if (user_is_leader || user_is_ambassador) {
      isProfile = true
    }
    if (isProfile) {
      if (user_is_ambassador) {
        redirectProfile = (
          <Link
            style={{ color: "#262626" }}
            to={`/ambassador/${LOCAL_AMBASSADOR_ID()}`}>
            {this.intl.profileOptions.myProfile}
          </Link>
        )
      } else if (user_is_leader) {
        redirectProfile = (
          <Link
            style={{ color: "#262626" }}
            to={`/leader/${LOCAL_EMPLOYEE_ID()}`}>
            {this.intl.profileOptions.myProfile}
          </Link>
        )
      } else {
        redirectProfile = (
          <Button
            style={{ padding: 0, border: "none", color: "#262626" }}
            type="link"
            onClick={this.changeRoleProfile}>
            Mi perfil
          </Button>
        )
      }
    }

    const { Item: ItemMenu } = Menu
    const menu = (
      <Menu className="container-userbox__options">
        <ItemMenu
          key={uuid()}
          onClick={() => {}}
          className="container-userbox__options-info"
          style={{
            borderBottom: `${
              transfer_user === "true" ? "" : "1px solid #f2f2f2"
            }`,
          }}>
          <div className="avatar-user">
            <Avatar
              id="test-avatar"
              src={picture_profile || LOCAL_USER_PHOTO()}
              size={40}
              icon={<UserOutlined />}
              style={{ marginLeft: 8, marginRight: 16 }}
            />
            <div className="info-user">
              <span className="user-info-name string_dots">
                  {split_first_name} {last_name}
              </span>
              <span className="user-info-email string_dots">
                {email !== null ? email : null}
              </span>
            </div>
          </div>
        </ItemMenu>
        {transfer_user === "true" && (
          <ItemMenu
            onClick={() => {}}
            key={uuid()}
            className="container-userbox__transfer_user">
            <div className="transfer-platform">
              <Button type="link" onClick={this.redirectPerformance}>
                <EmptySvg className="icon-performance" svg="iconPerformance" />
                <span>Desempeño</span>
              </Button>
            </div>
            <div className="transfer-platform-selected">
              <Button type="link">
                <img src={iconEngagement} style={{ paddingRight: "6px" }} />{" "}
                <span>Engagement</span>
              </Button>
            </div>
          </ItemMenu>
        )}
        {changeRole && <div className="visualize">VISUALIZACIÓN</div>}
        {changeRole && (
          <ItemMenu
            key={uuid()}
            className={`container-userbox__options-rol ${
              validRole({ role: [1, 2, 3, 4] }) ? "check" : ""
            }`}
            style={{
              padding: "8px 16px",
              margin: 0,
            }}
            onClick={
              validRole({ role: [ROLE_AMBASSADOR, ROLE_LEADER] })
                ? this.changeRole
                : null
            }>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}>
              <div>Administrador</div>
              {validRole({ role: [1, 2, 3, 4] }) ? (
                <img src={checkIcon} style={{ width: 13, height: 13 }} />
              ) : null}
            </div>
          </ItemMenu>
        )}
        {changeRole && (
          <ItemMenu
            key={uuid()}
            className={`container-userbox__options-rol ${
              validRole({ role: [ROLE_AMBASSADOR, ROLE_LEADER] }) ? "check" : ""
            }`}
            style={{
              padding: "8px 16px",
              margin: 0,
            }}
            onClick={validRole({ role: ROLES_ADMIN }) ? this.changeRole : null}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}>
              <div>
                {split_first_name} {last_name}
              </div>
              {validRole({ role: [ROLE_AMBASSADOR, ROLE_LEADER] }) ? (
                <img src={checkIcon} style={{ width: 13, height: 13 }} />
              ) : null}
            </div>
          </ItemMenu>
        )}
        {isProfile && (
          <ItemMenu
            key={uuid()}
            className="container-userbox__options-myprofile">
            {redirectProfile}
          </ItemMenu>
        )}
        <ItemMenu key={uuid()} className="container-userbox__options-myaccount">
          <Link to="/my-account">{this.intl.profileOptions.myAccount}</Link>
        </ItemMenu>
        <ItemMenu
          key={uuid()}
          className="container-userbox__options-logout"
          onClick={this.props.logout}>
          {this.intl.profileOptions.closeSession}
        </ItemMenu>
      </Menu>
    )

    return (
      <div className="userInfo">
        <Dropdown
          onVisibleChange={(visible) => this.openMenu(visible)}
          visible={this.state.visibleUserInfo}
          overlay={menu}
          placement="bottomRight">
          <div>
            <div className="avatar-user">
              <Avatar
                id="test-avatar"
                src={picture_profile || LOCAL_USER_PHOTO()}
                size={40}
                icon={<UserOutlined />}
                style={{ marginLeft: 8, marginRight: 16 }}
              />
              <span className="user-info-name string_dots">
                {changeRole === "Embajador" || changeRole === "Líder"
                  ? "Administrador"
                  : split_first_name}
              </span>
            </div>
            <img src={down} style={{ height: 16 }} alt="down" />
          </div>
        </Dropdown>
      </div>
    )
  }
}

UserBox.propTypes = {}

export default withRouter(UserBox)
